module.exports = __webpack_public_path__ + "img/ryzs11.a6cb79c0.jpg";